import tw from 'tailwind-styled-components'

export const EditSectorContainer = tw.div`
py-6
px-8
`

export const InputContainer = tw.form`
mb-[40px]
flex 
justify-between
items-center
flex-wrap
`

export const P = tw.p`
text-xs
text-darkGray 
font-medium
mb-8
`

export const ActionsButtons = tw.div`
flex 
gap-4
mt-[16.5px]
`

export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
border
border-blueTheme
rounded-lg
w-[130px]
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`